// extracted by mini-css-extract-plugin
export default {"link":"DN-z","disabled":"EN-z"};